<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>校务管理 / 户籍信息</span>
      </div>
      <div class="info-container">
        <el-form :rules="rules" ref="form" :model="form">
          <el-row
            style="margin-left: 0; margin-right: 0;"
            :gutter="24"
            type="flex"
            justify="end"
          >
            <el-col :span="10">
              <el-row :gutter="24" type="flex" align="middle">
                <el-col :span="6" style="text-align: right">
                  校长
                </el-col>
                <el-col :span="9">
                  <el-form-item prop="teacherName">
                    <el-input
                      v-if="editing"
                      v-model.trim="form.teacherName"
                      :maxlength="20"
                      placeholder="请输入姓名"
                    ></el-input>
                    <span v-else class="info-span" :title="form.teacherName">{{
                      form.teacherName || "-"
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item prop="teacherNum">
                    <el-input
                      v-if="editing"
                      v-model.trim="form.teacherNum"
                      :maxlength="20"
                      placeholder="请输入手机号"
                    ></el-input>
                    <span v-else class="info-span" :title="form.teacherNum">{{
                      form.teacherNum || "-"
                    }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="10">
              <el-row :gutter="24" type="flex" align="middle">
                <el-col :span="6" style="text-align: right">
                  网管员
                </el-col>
                <el-col :span="9">
                  <el-form-item prop="netAdminName">
                    <el-input
                      v-if="editing"
                      v-model.trim="form.netAdminName"
                      :maxlength="20"
                      placeholder="请输入姓名"
                    ></el-input>
                    <span v-else class="info-span" :title="form.netAdminName">{{
                      form.netAdminName || "-"
                    }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item prop="netAdminNum">
                    <el-input
                      v-if="editing"
                      v-model.trim="form.netAdminNum"
                      :maxlength="20"
                      placeholder="请输入手机号"
                    ></el-input>
                    <span v-else class="info-span" :title="form.netAdminNum">{{
                      form.netAdminNum || "-"
                    }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="4">
              <el-button
                v-if="!editing"
                type="primary"
                size="medium"
                @click="editInfo"
                >编辑</el-button
              >
              <template v-else>
                <el-button type="primary" size="medium" plain @click="cacelEdit"
                  >取消</el-button
                >
                <el-button type="primary" class="danger" size="medium" @click="confirmEdit"
                  >确定</el-button
                >
              </template>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="search-container">
        <el-row
          class="search-row"
          style="margin-left: 0; margin-right: 0;"
          :gutter="24"
        >
          <el-col :span="5">
            <el-select
              v-model="grade"
              placeholder="年级"
              @change="changeGrade"
              clearable
            >
              <el-option
                v-for="item in schoolGradeOption"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-select v-model="classId" placeholder="班级" clearable>
              <el-option
                v-for="item in classes"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model.trim="name"
              placeholder="姓名"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="4" style="text-align: center;">
            <el-button type="primary" size="medium" @click="initTable(1)"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <el-button type="primary" plain size="medium" @click="handleImport"
              >导入</el-button
            >
            <el-button type="primary" class="danger" plain size="medium" @click="handleExport"
              >导出未完成名单</el-button
            >
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table
              :data="pageData.t1"
              size="medium"
              :row-class-name="isRowAailable"
            >
              <el-table-column
                prop="regionName"
                min-width="60"
                label="区县"
              ></el-table-column>
              <el-table-column
                prop="schoolName"
                min-width="120"
                label="学校"
              ></el-table-column>
              <el-table-column
                prop="name"
                min-width="60"
                label="姓名"
              ></el-table-column>
              <el-table-column
                prop="gender"
                min-width="50"
                label="性别"
              ></el-table-column>
              <el-table-column
                prop="certificate"
                min-width="80"
                label="证件类型"
              >
              </el-table-column>
              <el-table-column
                prop="certificateNo"
                min-width="150"
                label="证件号码"
              ></el-table-column>
              <el-table-column
                prop="grade"
                min-width="60"
                label="年级"
              ></el-table-column>
              <el-table-column
                prop="className"
                min-width="80"
                label="班级"
              ></el-table-column>
              <el-table-column
                prop="heath"
                min-width="70"
                label="健康状况"
              ></el-table-column>
              <el-table-column prop="healthStatus" label="当前户籍">
                <el-table-column
                  prop="preSchoolDomicileProvince"
                  min-width="60"
                  label="省"
                ></el-table-column>
                <el-table-column
                  prop="preSchoolDomicileCity"
                  min-width="60"
                  label="市"
                ></el-table-column>
                <el-table-column
                  prop="preSchoolDomicileCounty"
                  min-width="60"
                  label="区县"
                ></el-table-column>
                <el-table-column
                  prop="preSchoolDetailAddress"
                  label="详细地址"
                  min-width="100"
                  ><template slot-scope="scope">
                    <span
                      class="address-ellipsis"
                      :title="scope.row.preSchoolDetailAddress"
                      >{{ scope.row.preSchoolDetailAddress }}</span
                    ></template
                  ></el-table-column
                ></el-table-column
              >
              <el-table-column prop="healthStatus" label="当前居住地">
                <el-table-column
                  prop="currentDomicileProvince"
                  min-width="60"
                  label="省"
                ></el-table-column>
                <el-table-column
                  prop="currentDomicileCity"
                  min-width="60"
                  label="市"
                ></el-table-column>
                <el-table-column
                  prop="currentDomicileCounty"
                  min-width="60"
                  label="区县"
                ></el-table-column>
                <el-table-column
                  prop="currentDomicileAddress"
                  label="详细地址"
                  min-width="100"
                  ><template slot-scope="scope">
                    <span
                      class="address-ellipsis"
                      :title="scope.row.currentDomicileAddress"
                      >{{ scope.row.currentDomicileAddress }}</span
                    ></template
                  ></el-table-column
                ></el-table-column
              >
              <el-table-column
                prop="classTeacherName"
                min-width="80"
                label="班主任姓名"
              ></el-table-column
              ><el-table-column
                prop="classTeacherPhone"
                min-width="100"
                label="班主任电话"
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row class="zyyj-pagination-row">
          <el-col :span="24">
            <el-pagination
              :total="pageData.t2"
              :current-page.sync="page"
              :page-sizes="[20, 50, 100]"
              :page-size.sync="size"
              background
              layout="total, sizes, prev, pager, next"
              @current-change="initTable"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>

    <excel-importer-box
      topic="人"
      action="/acc/students/outer-info/import"
      template="/acc/students/outer-info/templates"
      errorUrl="/acc/students/outer-info/fail/export"
      type="户籍信息"
      :visible.sync="importDialogVisible"
      @import-result="initTable(page)"
    >
      <template slot="if-failure">
        <el-table-column
          prop="objectName"
          label="学生姓名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="rowNum"
          label="所在行"
          width="100"
        ></el-table-column>
        <el-table-column prop="errorMessageList" label="导入失败原因">
          <template slot-scope="scope">
            <span v-for="(msg, index) in scope.row.errorMessageList" :key="msg">
              <span>{{ msg }}</span>
              <span v-if="index !== scope.row.errorMessageList.length - 1"
                >、</span
              >
            </span>
          </template>
        </el-table-column>
      </template>
    </excel-importer-box>
  </div>
</template>

<script>
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import ExcelImporterBox from '@/components/common/ExcelImporterBox'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'excel-importer-box': ExcelImporterBox
  },

  data() {
    var validatePhone = (rule, value, callback) => {
      if (
        /^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/.test(
          value
        ) === false
      ) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      pageData: {},
      size: 0,
      page: 1,
      grade: '',
      grades: [
        {
          name: '小学',
          value: 1,
          options: [
            {
              name: '一年级',
              value: 1
            },
            {
              name: '二年级',
              value: 2
            },
            {
              name: '三年级',
              value: 3
            },
            {
              name: '四年级',
              value: 4
            },
            {
              name: '五年级',
              value: 5
            },
            {
              name: '六年级',
              value: 6
            }
          ]
        },
        {
          name: '初中',
          value: 2,
          options: [
            {
              name: '初一年级',
              value: 7
            },
            {
              name: '初二年级',
              value: 8
            },
            {
              name: '初三年级',
              value: 9
            }
          ]
        },
        {
          name: '高中',
          value: 3,
          options: [
            {
              name: '高一年级',
              value: 10
            },
            {
              name: '高二年级',
              value: 11
            },
            {
              name: '高三年级',
              value: 12
            }
          ]
        },
        {
          name: '九年一贯制',
          value: 4,
          options: [
            {
              name: '一年级',
              value: 1
            },
            {
              name: '二年级',
              value: 2
            },
            {
              name: '三年级',
              value: 3
            },
            {
              name: '四年级',
              value: 4
            },
            {
              name: '五年级',
              value: 5
            },
            {
              name: '六年级',
              value: 6
            },
            {
              name: '七年级',
              value: 7
            },
            {
              name: '八年级',
              value: 8
            },
            {
              name: '九年级',
              value: 9
            }
          ]
        }
      ],
      classId: '',
      classes: [],
      name: '',
      importDialogVisible: false,
      idTypes: [
        {
          name: '居民身份证',
          value: 1
        },
        {
          name: '香港特区护照／身份证明',
          value: 2
        },
        {
          name: '澳门特区护照／身份证明',
          value: 3
        },
        {
          name: '台湾居民来往大陆身份证明',
          value: 4
        },
        {
          name: '外籍护照',
          value: 5
        }
      ],
      gender: [
        {
          name: '男',
          value: 1
        },
        {
          name: '女',
          value: 2
        }
      ],
      editing: false,
      form: {
        teacherId: null,
        teacherName: '',
        teacherNum: '',
        netAdminId: null,
        netAdminName: '',
        netAdminNum: ''
      },
      cloneForm: {
        teacherId: null,
        teacherName: '',
        teacherNum: '',
        netAdminId: null,
        netAdminName: '',
        netAdminNum: ''
      },
      rules: {
        teacherName: [
          { required: true, message: '姓名不得为空', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        teacherNum: [
          {
            required: true,
            message: '手机号不得为空',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          },
          { validator: validatePhone, trigger: 'blur' }
        ],
        netAdminName: [
          { required: true, message: '姓名不得为空', trigger: 'blur' },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        netAdminNum: [
          {
            required: true,
            message: '手机号不得为空',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          },
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },

  watch: {},

  computed: {
    _() {
      return _
    },

    schoolGradeOption() {
      return _.filter(this.grades, {
        value: this.$store.getters['user/getSchoolStage']()
      })[0].options
    }
  },

  mounted() {
    this.initInfo()
    this.initTable()
  },

  methods: {
    initTable(page) {
      if (page) {
        this.page = page
      }
      let queryParam = {
        grade: this.grade,
        classId: this.classId,
        name: this.name,
        size: this.size || 20,
        page: this.page
      }
      this.$xhrGet(`/acc/students/outer-info/list`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    initInfo() {
      // 获取校长 网管员 信息
      this.$xhrGet(`/acc/school-principal`).then(rs => {
        if (rs.data && rs.data.length > 0) {
          let typeOne = _.filter(rs.data, { type: 1 })
          let typeTwo = _.filter(rs.data, { type: 2 })
          this.form.teacherId = typeOne && typeOne[0].id
          this.form.teacherName = typeOne && typeOne[0].name
          this.form.teacherNum = typeOne && typeOne[0].phone
          this.form.netAdminId = typeTwo && typeTwo[0].id
          this.form.netAdminName = typeTwo && typeTwo[0].name
          this.form.netAdminNum = typeTwo && typeTwo[0].phone
        }
        this.cloneForm = _.cloneDeep(this.form)
      })
    },

    changeGrade(val) {
      this.classId = ''
      if (!val) {
        this.classes = []
        return false
      }
      this.$xhrGet(`/acc/classes/grade/${val}`).then(rs => {
        this.classes = rs.data
      })
    },

    handleSizeChange(val) {
      this.size = val
      this.page = 1
      let queryParam = {
        grade: this.grade,
        classId: this.classId,
        name: this.name,
        size: this.size,
        page: this.page
      }
      this.$xhrGet(`/acc/students/outer-info/list`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    handleExport () {
      this.$fetchFile('/acc/students/outer-info/incomplete', { name: '户籍信息未完成导入学生名单' })
    },

    handleImport() {
      this.importDialogVisible = true
    },

    isRowAailable({ row, rowIndex }) {
      return 'zyyj-row-available-' + row.available
    },

    editInfo() {
      this.editing = true
    },

    cacelEdit() {
      this.$refs.form && this.$refs.form.clearValidate()
      this.form = _.cloneDeep(this.cloneForm)
      this.editing = false
    },

    xhrEditInfo() {
      let temp = []
      let headMaster = {
        name: this.form.teacherName,
        phone: this.form.teacherNum,
        id: this.form.teacherId,
        type: 1
      }
      let netAdmin = {
        name: this.form.netAdminName,
        phone: this.form.netAdminNum,
        id: this.form.netAdminId,
        type: 2
      }
      temp.push(headMaster)
      temp.push(netAdmin)
      this.$xhrPost(`/acc/school-principal`, temp).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.editing = false
          this.initInfo()
        } else {
        }
      })
    },

    confirmEdit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.xhrEditInfo()
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.search-container {
  width: calc(100% - 80px);
  height: 76px;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.info-container {
  width: calc(100% - 40px);
  height: 73px;
  line-height: 73px;
  margin: 20px;
  background: #fff;
  border-radius: 6px;
}
.search-row {
  height: 100%;
  padding: 20px;
  background: #f9f9f9;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 364px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
/deep/ .el-input__inner {
  height: 36px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
.danger {
  color: red !important;
  border: 1px solid rgb(255, 176, 176) !important;
}

.danger:hover,
.danger:focus {
  color: red !important;
  border: 1px solid red !important;
}
.info-span {
  display: inline-block;
  content: "";
  width: 90%;
  position: absolute;
  top: -20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
.address-ellipsis {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/OuterInfoManage.vue